import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { ThemeProvider } from './context/ThemeContext';
import { PlanspielPage } from './pages/PlanspielPage';
import { useMobileLayout } from './hooks/use-mobile';
import './App.css';

function App() {
  // Auf dem Handy liegen unten Bedienleiste und Kontextleiste, Meldungen daher oben
  const isMobile = useMobileLayout();

  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PlanspielPage />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster 
          position={isMobile ? 'top-center' : 'bottom-right'}
          toastOptions={{
            className: 'font-sans',
          }}
        />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
